// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Title_wrapper__DIf2F","secondary":"Title_secondary__LSHDu","inter":"Title_inter__1zn2y","bold":"Title_bold__yjKsP"};